import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { FilterService } from '../../components/filters/services/filters.service';
import { Subscription } from 'rxjs';
import { MenusComponent } from '../menus/menus.component';
import { UserProfileHeaderComponent } from '../../../features/Perfil/components/user-profile-header/user-profile-header.component';
import { FiltroDesktopComponent } from '../../components/filters/filtro-desktop/filtro-desktop.component';
import { NotificacaoBarComponent } from '../../../features/Feed/components/notificacao-bar/notificacao-bar.component';
import { NotificacaoBarService } from '../../../features/Feed/services/notifcacaoBar.service';
import { PedidoFilterService } from '../../components/filters/services/pedidos-filter.service';
import { FilterConsultaPedidosComponent } from '../../components/filters/filter-consulta-pedidos/filter-consulta-pedidos.component';
import { AvaliacaoFilterService } from '../../components/filters/services/avaliacao-filter.service';
import { AvaliacaoFilterComponent } from '../../components/filters/filter-avaliacao/filter-avaliacao.component';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    RouterOutlet,
    CommonModule,
    NgIf,
    FiltroDesktopComponent,
    MenusComponent,
    RouterModule,
    UserProfileHeaderComponent,
    FilterConsultaPedidosComponent,
    NotificacaoBarComponent,
    AvaliacaoFilterComponent
  ]
})
export class SidenavComponent {
  constructor(private _authService: AuthService,
    private router: Router,
    private filterService: FilterService,
    private avaliacaoFilterService: AvaliacaoFilterService,
    private pedidosFilterService: PedidoFilterService,
    private notificacaoBarService: NotificacaoBarService
  ) { }
  isExpanded: boolean = true;
  filtroAberto: boolean = false;
  filtroPedidosAberto: boolean = false;
  filtroAvaliacaoAberto: boolean = false;
  notificacaoAberta: boolean = false;
  isMobile: boolean = false;
  private sub!: Subscription;

  ngOnInit() {
    if (window.innerWidth <= 950) {
      this.isMobile = true;
      this.isExpanded = false;
    }
    this.filterService.filtroAberto$.subscribe(aberto => {
      this.filtroAberto = aberto;
    });

    this.avaliacaoFilterService.filtroAberto$.subscribe(aberto => {
      this.filtroAvaliacaoAberto = aberto;
    });

    this.pedidosFilterService.filtroAberto$.subscribe(aberto => {
      this.filtroPedidosAberto = aberto;
    });

    this.notificacaoBarService.notificacaoBarAberto$.subscribe(aberto => {
      this.notificacaoAberta = aberto;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  home() {
    this.router.navigate(['/home']);
    this.isExpanded = false;
  }


  fecharDrawer() {
    this.filterService.fechar();
    this.avaliacaoFilterService.fechar();
    this.pedidosFilterService.fechar();
    this.notificacaoBarService.fechar();
  }

  toggleSidenav() {
    this.isExpanded = !this.isExpanded;
  }

  logout() {
    this._authService.logout();
  }


}
